export type SubjectTone =
  | "lang"
  | "math"
  | "science"
  | "art"
  | "rose"
  | "teal"
  | "sun"
  | "neutral";

const TONES: Array<[SubjectTone, string[]]> = [
  ["lang", ["русск", "литерат", "чтение", "грамот", "развитие речи", "английск"]],
  ["math", ["математ", "алгебр", "геометр", "робот", "шахмат"]],
  ["science", ["физик", "хими", "биолог", "мир вокруг", "здоровыми", "страновед"]],
  ["art", ["музык", "художествен", "изо", "танц", "хор", "театр"]],
];

export const subjectTone = (subject: string): SubjectTone => {
  const value = subject.toLowerCase();
  const found = TONES.find(([, keys]) => keys.some((key) => value.includes(key)));
  return found ? found[0] : "neutral";
};

export const toneColors: Record<SubjectTone, { bg: string; border: string; text: string }> = {
  lang: { bg: "#eef4e2", border: "#cbdcae", text: "#41630a" },
  math: { bg: "#e6f1f5", border: "#bcd9e3", text: "#1f5468" },
  science: { bg: "#fdf0e3", border: "#f2d6b3", text: "#8a5312" },
  art: { bg: "#f3ecf8", border: "#dccdea", text: "#5c3b7a" },
  rose: { bg: "#fdecef", border: "#f2c9d2", text: "#8a2740" },
  teal: { bg: "#e4f3ef", border: "#bcded4", text: "#16604f" },
  sun: { bg: "#fdf6db", border: "#eee0a8", text: "#6b5410" },
  neutral: { bg: "#f4f6f0", border: "#e3e9d6", text: "#4d5848" },
};
